"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationSettings = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIcons = require("@100mslive/react-icons");
var _reactUi = require("@100mslive/react-ui");
var _SwitchWithLabel = _interopRequireDefault(require("./SwitchWithLabel"));
var _useUISettings = require("../AppData/useUISettings");
var _constants = require("../../common/constants");
var _common = require("./common.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var NotificationItem = function NotificationItem(_ref) {
  var type = _ref.type,
    label = _ref.label,
    icon = _ref.icon,
    checked = _ref.checked;
  var _useSetSubscribedNoti = (0, _useUISettings.useSetSubscribedNotifications)(type),
    _useSetSubscribedNoti2 = _slicedToArray(_useSetSubscribedNoti, 2),
    setSubscribedNotifications = _useSetSubscribedNoti2[1];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SwitchWithLabel["default"], {
    label: label,
    id: type,
    icon: icon,
    checked: checked,
    onChange: function onChange(value) {
      setSubscribedNotifications(value);
    }
  });
};
var NotificationSettings = function NotificationSettings() {
  var subscribedNotifications = (0, _useUISettings.useSubscribedNotifications)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Box, {
    className: (0, _common.settingOverflow)(),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(NotificationItem, {
      label: "Peer Joined",
      type: _constants.SUBSCRIBED_NOTIFICATIONS.PEER_JOINED,
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.PersonIcon, {}),
      checked: subscribedNotifications.PEER_JOINED
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(NotificationItem, {
      label: "Peer Leave",
      type: _constants.SUBSCRIBED_NOTIFICATIONS.PEER_LEFT,
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ExitIcon, {}),
      checked: subscribedNotifications.PEER_LEFT
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(NotificationItem, {
      label: "New Message",
      type: _constants.SUBSCRIBED_NOTIFICATIONS.NEW_MESSAGE,
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ChatIcon, {}),
      checked: subscribedNotifications.NEW_MESSAGE
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(NotificationItem, {
      label: "Hand Raised",
      type: _constants.SUBSCRIBED_NOTIFICATIONS.METADATA_UPDATED,
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.HandIcon, {}),
      checked: subscribedNotifications.METADATA_UPDATED
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(NotificationItem, {
      label: "Error",
      type: _constants.SUBSCRIBED_NOTIFICATIONS.ERROR,
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.AlertOctagonIcon, {}),
      checked: subscribedNotifications.ERROR
    })]
  });
};
exports.NotificationSettings = NotificationSettings;